export default {
  admin: {
    title: "Users",
    newUser: "+ New user",
    errorPrefix: "Error: ",
    userCreated: "User created",
    userUpdated: "User updated",
    userDeleted: "User deleted",
    readonlyNoticePre: "Your organization's user team is managed by HelixScan. To add, modify or remove users, write to us at ",
    readonlyNoticePost: ".",
    colName: "Name",
    colEmail: "Email",
    colRole: "Role",
    colStatus: "Status",
    colCreated: "Created",
    colLastLogin: "Last login",
    colActions: "Actions",
    you: "(you)",
    active: "Active",
    inactive: "Inactive",
    never: "Never",
    edit: "Edit",
    activate: "Activate",
    deactivate: "Deactivate",
    delete: "Delete",
    noUsers: "No users",
    confirmDeleteTitle: "Delete user?",
    confirmDeleteMsg: "This action cannot be undone.",
    modalCreateTitle: "New user",
    modalEditTitle: "Edit user",
    fieldFirstName: "First name",
    fieldLastName: "Last name",
    fieldEmail: "Email *",
    fieldPassword: "Password *",
    fieldRole: "Role",
    fieldNewPassword: "New password",
    fieldNewPasswordHint: "(leave blank to keep unchanged)",
    cancel: "Cancel",
    createUser: "Create user",
    saveChanges: "Save changes",
  },
};
